import React, { useContext } from "react";
import { Button, Typography, Modal, theme, Tag, message } from "antd";
import buttonStyles from "../../../styles/Custom/Button.module.css";
import textStyles from "../../../styles/Custom/Typography.module.css";
import tagStyles from "../../../styles/Custom/Tag.module.css";

import {
  ACTIVEDOMAIN,
  FacilityID,
  ORGANISATONID,
  Role,
} from "../../../constants/defaultKeys";
import {
  capitalizeFirstLetter,
  redirectToDashboard,
} from "../../../helpers/auth/helper";
import { getCookie, setCookie } from "../../../helpers/localStorage";
import "./Login.css";
import { UserContext } from "../../../context/UserContext";
import CustomAvatar from "../../../blocks/Avatars/CustomAvatar";
import styles from "../../../styles/Custom/Dashboard/ChooseOrg.module.css";
import { setOneSignalUser } from "../../../onesignal";

const { useToken } = theme;

const onlyPartnerRole = (org) => {
  return org?.roles?.length === 1 && org?.roles?.[0]?.role === "Partner";
};

const ChooseOrgModal = ({ openModal, closable, onCancel }) => {
  const { userDetails, setUserDetails } = useContext(UserContext);
  const { token } = useToken();
  const defaultRole = userDetails?.currRole || getCookie(Role);
  const facility_id = userDetails?.currFacility || getCookie(FacilityID);
  const roleObj = userDetails?.activeOrg?.roles?.find(
    (record) =>
      record.role === defaultRole && record.facility_id === Number(facility_id)
  );

  return (
    <Modal
      open={openModal}
      centered
      onCancel={onCancel}
      footer={null}
      closable={closable}
      wrapClassName="orgModalWrap"
      style={{ textAlign: "center", padding: "0px", position: "relative" }}
      className={styles?.orgModal}
    >
      <div
        className={styles.orgModalHeader}
        style={{
          padding: "24px",
          background: "url('/images/auth/headerStars.png') no-repeat",
          backgroundPosition: "top center",
          backgroundSize: "auto 170px",
        }}
      >
        <Typography
          className={`text-center ${textStyles.h6} ${styles.orgModalTitle}`}
          style={{ marginBlock: "12px" }}
        >
          Choose Organisation
        </Typography>

        <div
          className={`${styles.scrollDiv} org-scroll`}
          style={{
            maxHeight: "50vh",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {userDetails?.organizations?.map((org) => {
            return (
              <div key={org?.org_id}>
                {!onlyPartnerRole(org) && (
                  <Button
                    key={org?.org_name}
                    className={`orgButton ${buttonStyles.mdBtn} ${
                      org?.is_inactive && "orgErrorButton"
                    }`}
                    style={{
                      width: "100%",
                      marginTop: "12px",
                      justifyContent: "flex-start",
                      paddingBlock: "16px",
                    }}
                    onClick={() => {
                      if (!org?.is_inactive) {
                        // 🔥 Fire and forget — don't await, don't block redirect
                        setOneSignalUser(userDetails?.onesignal_player_id);

                        setUserDetails({
                          ...userDetails,
                          activeOrg: org,
                          currFacility: org?.roles?.[0]?.facility_id,
                          currRole: org?.roles?.[0]?.role,
                        });
                        setCookie(
                          ORGANISATONID,
                          org?.org_id,
                          `.${process.env.REACT_APP_PUBLIC_DOMAIN}`,
                          "/"
                        );
                        setCookie(
                          FacilityID,
                          org?.roles?.[0]?.facility_id,
                          `.${process.env.REACT_APP_PUBLIC_DOMAIN}`,
                          "/"
                        );
                        setCookie(
                          Role,
                          org?.roles?.[0]?.role,
                          `.${process.env.REACT_APP_PUBLIC_DOMAIN}`,
                          "/"
                        );

                        if (org?.domain) {
                          setCookie(
                            ACTIVEDOMAIN,
                            org?.domain,
                            `.${process.env.REACT_APP_PUBLIC_DOMAIN}`,
                            "/"
                          );
                          redirectToDashboard(
                            org?.domain,
                            org?.roles?.[0]?.role,
                            org?.roles?.[0]
                          );
                        } else {
                          message?.error("No domain found");
                        }
                      }
                    }}
                  >
                    <div className="org-row">
                      <div className="org-row__main">
                        <CustomAvatar
                          name={org?.org_name}
                          indexId={org?.org_id}
                        />
                        <div className="org-row__text">
                          <span className="org-row__name">
                            {capitalizeFirstLetter(org?.org_name)}
                          </span>
                          <Tag
                            color="blue"
                            className={`${tagStyles.smRndTag} org-row__role`}
                          >
                            {[
                              org?.roles?.[0]?.role?.replaceAll("_", " "),
                              org?.roles?.[0]?.clinical_role_name,
                            ]
                              .filter(Boolean)
                              .join(" - ")}
                          </Tag>
                        </div>
                      </div>
                      {org?.is_inactive && (
                        <Tag
                          color="red"
                          className={`${tagStyles.mdRndTag} org-row__denied`}
                        >
                          Access Denied
                        </Tag>
                      )}
                    </div>
                  </Button>
                )}
                {org?.is_inactive && (
                  <div className={"orgButtonError"}>
                    <Typography
                      style={{
                        color: token.colorErrorHover,
                        fontWeight: 500,
                        textAlign: "left",
                      }}
                    >
                      User ID disabled
                    </Typography>
                    <Typography style={{ textAlign: "left", fontSize: "12px" }}>
                      {
                        "Your user ID has been disabled. Please contact support (9154372355) for assistance."
                      }
                    </Typography>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );
};

export default ChooseOrgModal;
